import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Button,
  Label,
  Input,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import AdminUserEditNotificationsItem from './NotificationsItem';
import AdminUserEditNotificationsDesktop from './NotificationsDesktop';

import ErrorBoundary from '../../ErrorBoundary';
import HelpIcon from '../../HelpIcon';

const AdminUserEditNotifications = (props) => {
  const intl = useIntl();

  const {
    profile,
    notificationSound,
    isSelfEdit,
    handleNotificationChange,
    handleNotificationSoundChange,
  } = props;

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <h4>
          {intl.formatMessage({ defaultMessage: 'Notifications' })}
        </h4>
        <AdminUserEditNotificationsDesktop />

        <div className="notification-sound-option">
          <Label className="switch" htmlFor="notification-sound">
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                id="notification-sound"
                name="notification-sound"
                value={true}
                checked={notificationSound}
                onChange={handleNotificationSoundChange}
              />
              <i />
            </div>
            {intl.formatMessage({ defaultMessage: 'Play sound on new notifications' })}
          </Label>
        </div>
        <hr />

        <div className="user-notifications">
          <ListGroup flush className="switch-list notifications-settings-list">
            <ListGroupItem className="list-group-item-notification-header">
              <h5>
                {intl.formatMessage({ defaultMessage: 'Notify me when...' })}
              </h5>
              <div className="actions">
                {(
                  profile.notification_channels_active &&
                  !profile.notification_channels_active.includes('slack')
                ) && (
                  <>
                    {isSelfEdit ? (
                      <Button tag={Link} size="sm" to="/integrations/slack">
                        {intl.formatMessage({ defaultMessage: 'Connect to Slack' })}
                      </Button>
                    ) : (
                      <HelpIcon>
                        {intl.formatMessage({ defaultMessage: 'This user has no active Slack connection' })}
                      </HelpIcon>
                    )}
                  </>
                )}
              </div>
            </ListGroupItem>
            {Object.keys(profile.notifications).map(notificationId => (
              <AdminUserEditNotificationsItem
                key={notificationId}
                notificationId={profile.notifications[notificationId].notification_id}
                notification={profile.notifications[notificationId]}
                channels={profile.notification_channels}
                enabledChannels={profile.notification_channels_active}
                handleNotificationChange={handleNotificationChange}
              />
            ))}
          </ListGroup>
        </div>
      </div>
      <AdminEditButtons
        {...props}
        hideDelete={true}
      />
    </ErrorBoundary>
  );
};

AdminUserEditNotifications.propTypes = {
  profile: PropTypes.object.isRequired,
  notificationSound: PropTypes.bool.isRequired,
  isSelfEdit: PropTypes.bool.isRequired,
  handleNotificationChange: PropTypes.func.isRequired,
  handleNotificationSoundChange: PropTypes.func.isRequired,
};

export default AdminUserEditNotifications;
